import { render } from "./App.vue?vue&type=template&id=0997a61e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0997a61e&lang=css"

import exportComponent from "/Users/h5/Desktop/project/外包/shugutong/yxLink/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__